import { h } from "preact";
import styles from './styles.scss';

const Icon = props => {
    const {name, screenReaderText, icon} = props;
    return (
        <span class={styles.icon}>
            {icon}
            <span class="screen-reader-text">{screenReaderText}</span>
        </span>
    )
}

Icon.defaultProps = {
    name: "none",
    screenReaderText: "icon",
    icon: null
};

export default Icon;


// WEBPACK FOOTER //
// ./components/Icons/Icon.js